import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5754f546"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "collapse show" }
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "row mb-6" }
const _hoisted_5 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_6 = { class: "col-lg-8 fv-row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = {
  key: 0,
  class: "col text-end"
}
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-4 fv-row" }
const _hoisted_15 = { class: "pt-5" }
const _hoisted_16 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1))
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "col-lg-8 fv-row" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "row mb-6" }
const _hoisted_36 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_37 = { class: "col-lg-8 fv-row" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = { class: "row mb-6" }
const _hoisted_50 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "col-lg-8 fv-row" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "row mb-6" }
const _hoisted_57 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_58 = { class: "col-lg-8 fv-row" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "row mb-6" }
const _hoisted_64 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_65 = { class: "col-lg-8 fv-row" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_68 = { class: "fv-plugins-message-container" }
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_71 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_72 = { class: "col-lg-8 fv-row" }
const _hoisted_73 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_74 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_75 = { class: "col-lg-8 fv-row" }
const _hoisted_76 = { class: "row mb-6" }
const _hoisted_77 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_78 = { class: "col-lg-8 fv-row" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_81 = { class: "fv-plugins-message-container" }
const _hoisted_82 = { class: "fv-help-block" }
const _hoisted_83 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_84 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_85 = { class: "col-lg-8 fv-row" }
const _hoisted_86 = { class: "row" }
const _hoisted_87 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_88 = { class: "fv-plugins-message-container" }
const _hoisted_89 = { class: "fv-help-block" }
const _hoisted_90 = {
  key: 3,
  class: "row mb-6"
}
const _hoisted_91 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_92 = { class: "col-lg-8 fv-row" }
const _hoisted_93 = { class: "row" }
const _hoisted_94 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_95 = { class: "fv-plugins-message-container" }
const _hoisted_96 = { class: "fv-help-block" }
const _hoisted_97 = {
  key: 4,
  class: "row mb-6"
}
const _hoisted_98 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_99 = { class: "col-lg-8 fv-row" }
const _hoisted_100 = { class: "row" }
const _hoisted_101 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_102 = { class: "fv-plugins-message-container" }
const _hoisted_103 = { class: "fv-help-block" }
const _hoisted_104 = {
  key: 5,
  class: "row mb-6"
}
const _hoisted_105 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_106 = { class: "col-lg-8 fv-row" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_109 = { class: "fv-plugins-message-container" }
const _hoisted_110 = { class: "fv-help-block" }
const _hoisted_111 = {
  key: 6,
  class: "row mb-6"
}
const _hoisted_112 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_113 = { class: "col-lg-8 fv-row" }
const _hoisted_114 = { class: "row" }
const _hoisted_115 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_116 = { class: "fv-plugins-message-container" }
const _hoisted_117 = { class: "fv-help-block" }
const _hoisted_118 = {
  key: 7,
  class: "row mb-6"
}
const _hoisted_119 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_120 = { class: "col-lg-8 fv-row" }
const _hoisted_121 = { class: "row" }
const _hoisted_122 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_123 = {
  key: 8,
  class: "row mb-6"
}
const _hoisted_124 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_125 = { class: "col-lg-8 fv-row" }
const _hoisted_126 = { class: "row" }
const _hoisted_127 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_128 = { class: "fv-plugins-message-container" }
const _hoisted_129 = { class: "fv-help-block" }
const _hoisted_130 = {
  key: 9,
  class: "row mb-6"
}
const _hoisted_131 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_132 = { class: "col-lg-8 fv-row" }
const _hoisted_133 = { class: "row" }
const _hoisted_134 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_135 = { class: "fv-plugins-message-container" }
const _hoisted_136 = { class: "fv-help-block" }
const _hoisted_137 = {
  key: 10,
  class: "row mb-6"
}
const _hoisted_138 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_139 = { class: "col-lg-8 fv-row" }
const _hoisted_140 = { class: "row" }
const _hoisted_141 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_142 = { class: "fv-plugins-message-container" }
const _hoisted_143 = { class: "fv-help-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EstadoTag = _resolveComponent("EstadoTag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Page, { showBack: "" }, {
    actions: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.guardar,
        loading: _ctx.crearCurso
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.guardar")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, { type: "border-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.inscripcionDetalle.datosInscripcionGroup')
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(), 1),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("listados.inscripcion.estado.label")), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_el_select_v2, {
                              modelValue: _ctx.estado,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.estado) = $event)),
                              class: "w-100",
                              options: _ctx.estados,
                              placeholder: 
                          _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                        
                            }, null, 8, ["modelValue", "options", "placeholder"]),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_ErrorMessage, { name: "estado" })
                              ])
                            ])
                          ]),
                          (_ctx.estadoOriginal)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_EstadoTag, { estado: _ctx.estadoOriginal }, null, 8, ["estado"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.fecha.label")), 1),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          placeholder: " ",
                          value: _ctx.formatDate(_ctx.createdOn),
                          disabled: ""
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.datosIncripcion")), 1)
                    ]),
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.nombreApellidos")), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "nombre",
                              placeholder: " ",
                              modelValue: _ctx.nombre,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombre) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_ErrorMessage, { name: "nombre" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "apellidos",
                              placeholder: " ",
                              modelValue: _ctx.apellidos,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apellidos) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_ErrorMessage, { name: "apellidos" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.dni.label")), 1),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "dni",
                              placeholder: " ",
                              modelValue: _ctx.dni,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dni) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _createVNode(_component_ErrorMessage, { name: "dni" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.email.label")), 1),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "email",
                              placeholder: " ",
                              modelValue: _ctx.email,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createVNode(_component_ErrorMessage, { name: "email" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.telefono.label")), 1),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_el_input, {
                              type: "tel",
                              name: "telefono",
                              placeholder: " ",
                              modelValue: _ctx.telefono,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telefono) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createVNode(_component_ErrorMessage, { name: "telefono" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.provincia.label")), 1),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createVNode(_component_el_select_v2, {
                              modelValue: _ctx.provincia,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.provincia) = $event)),
                              class: "w-100",
                              options: _ctx.provincias,
                              placeholder: 
                          _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                        ,
                              onChange: _ctx.updateLocalidades
                            }, null, 8, ["modelValue", "options", "placeholder", "onChange"]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_component_ErrorMessage, { name: "provincia" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.localidad.label")), 1),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_el_select_v2, {
                              modelValue: _ctx.localidad,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localidad) = $event)),
                              class: "w-100",
                              options: _ctx.localidadesFiltradas,
                              placeholder: 
                          _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                        ,
                              filterable: ""
                            }, null, 8, ["modelValue", "options", "placeholder"]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _createVNode(_component_ErrorMessage, { name: "localidad" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.codigoPostal.label")), 1),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(_component_el_input, {
                              type: "tel",
                              name: "codigoPostal",
                              placeholder: " ",
                              modelValue: _ctx.codigoPostal,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.codigoPostal) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _createVNode(_component_ErrorMessage, { name: "codigoPostal" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.cursoPresencial)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                          _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.presencial.label")), 1),
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_component_el_switch, {
                              modelValue: _ctx.presencial,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.presencial) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "presencial",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cursoVideoconferencia)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.videoconferencia.label")), 1),
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(_component_el_switch, {
                              modelValue: _ctx.videoconferencia,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.videoconferencia) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "videoconferencia",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t("listados.inscripcionDetalle.perfil.label")), 1),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createVNode(_component_el_select_v2, {
                              modelValue: _ctx.perfil,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.perfil) = $event)),
                              class: "w-100",
                              options: _ctx.optionsPerfil,
                              placeholder: 
                          _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                        
                            }, null, 8, ["modelValue", "options", "placeholder"]),
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", _hoisted_82, [
                                _createVNode(_component_ErrorMessage, { name: "perfil" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.perfil === 'EMPRESA')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                          _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.nombreEmpresa.label")), 1),
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("div", _hoisted_87, [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  name: "nombreEmpresa",
                                  placeholder: " ",
                                  modelValue: _ctx.nombreEmpresa,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.nombreEmpresa) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_88, [
                                  _createElementVNode("div", _hoisted_89, [
                                    _createVNode(_component_ErrorMessage, { name: "nombreEmpresa" })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.perfil === 'EMPRESA')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                          _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.localidadEmpresa.label")), 1),
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, [
                              _createElementVNode("div", _hoisted_94, [
                                _createVNode(_component_el_select_v2, {
                                  modelValue: _ctx.localidadEmpresa,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.localidadEmpresa) = $event)),
                                  class: "w-100",
                                  options: _ctx.localidadesTodas,
                                  placeholder: 
                          _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                        ,
                                  filterable: ""
                                }, null, 8, ["modelValue", "options", "placeholder"]),
                                _createElementVNode("div", _hoisted_95, [
                                  _createElementVNode("div", _hoisted_96, [
                                    _createVNode(_component_ErrorMessage, { name: "localidadEmpresa" })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.perfil === 'EMPRESA')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                          _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.cifEmpresa.label")), 1),
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, [
                              _createElementVNode("div", _hoisted_101, [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  name: "cifEmpresa",
                                  placeholder: " ",
                                  modelValue: _ctx.cifEmpresa,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.cifEmpresa) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_102, [
                                  _createElementVNode("div", _hoisted_103, [
                                    _createVNode(_component_ErrorMessage, { name: "cifEmpresa" })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (
                  _ctx.perfil === 'EMPRESA' ||
                  _ctx.perfil === 'ASOCIACION' ||
                  _ctx.perfil === 'EMPRENDEDORA'
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                          _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.sectorEmpresa.label")), 1),
                          _createElementVNode("div", _hoisted_106, [
                            _createElementVNode("div", _hoisted_107, [
                              _createElementVNode("div", _hoisted_108, [
                                _createVNode(_component_el_select_v2, {
                                  modelValue: _ctx.sectorEmpresa,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.sectorEmpresa) = $event)),
                                  name: "sectorEmpresa",
                                  class: "w-100",
                                  options: _ctx.sectoresTodos,
                                  placeholder: 
                          _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                        ,
                                  filterable: ""
                                }, null, 8, ["modelValue", "options", "placeholder"]),
                                _createElementVNode("div", _hoisted_109, [
                                  _createElementVNode("div", _hoisted_110, [
                                    _createVNode(_component_ErrorMessage, { name: "sectorEmpresa" })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.perfil === 'PROFESIONAL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                          _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.sectorEmpresa.label")), 1),
                          _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("div", _hoisted_114, [
                              _createElementVNode("div", _hoisted_115, [
                                _createVNode(_component_el_select_v2, {
                                  modelValue: _ctx.sectorEmpresa,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.sectorEmpresa) = $event)),
                                  name: "sectorEmpresa",
                                  class: "w-100",
                                  options: _ctx.sectoresProfesionalesTodos,
                                  placeholder: 
                          _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                        ,
                                  filterable: ""
                                }, null, 8, ["modelValue", "options", "placeholder"]),
                                _createElementVNode("div", _hoisted_116, [
                                  _createElementVNode("div", _hoisted_117, [
                                    _createVNode(_component_ErrorMessage, { name: "sectorEmpresa" })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cursoEmprendimiento)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                          _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t(
                      "formularios.inscripcionDetalle.proyectoEmprendimiento.label"
                    )), 1),
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("div", _hoisted_121, [
                              _createElementVNode("div", _hoisted_122, [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.proyectoEmprendimiento,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.proyectoEmprendimiento) = $event)),
                                  width: "100%",
                                  autosize: { minRows: 2, maxRows: 4 },
                                  type: "textarea",
                                  placeholder: " "
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "proyectoEmprendimiento",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.perfil === 'EMPRESA')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                          _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.empleadosEmpresa.label")), 1),
                          _createElementVNode("div", _hoisted_125, [
                            _createElementVNode("div", _hoisted_126, [
                              _createElementVNode("div", _hoisted_127, [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  name: "empleadosEmpresa",
                                  placeholder: " ",
                                  modelValue: _ctx.empleadosEmpresa,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.empleadosEmpresa) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_128, [
                                  _createElementVNode("div", _hoisted_129, [
                                    _createVNode(_component_ErrorMessage, { name: "empleadosEmpresa" })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.perfil === 'PROFESIONAL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                          _createElementVNode("label", _hoisted_131, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.entidad.label")), 1),
                          _createElementVNode("div", _hoisted_132, [
                            _createElementVNode("div", _hoisted_133, [
                              _createElementVNode("div", _hoisted_134, [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  name: "entidad",
                                  placeholder: " ",
                                  modelValue: _ctx.entidad,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.entidad) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_135, [
                                  _createElementVNode("div", _hoisted_136, [
                                    _createVNode(_component_ErrorMessage, { name: "entidad" })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.perfil === 'PROFESIONAL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                          _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.puesto.label")), 1),
                          _createElementVNode("div", _hoisted_139, [
                            _createElementVNode("div", _hoisted_140, [
                              _createElementVNode("div", _hoisted_141, [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  name: "puesto",
                                  placeholder: " ",
                                  modelValue: _ctx.puesto,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.puesto) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_142, [
                                  _createElementVNode("div", _hoisted_143, [
                                    _createVNode(_component_ErrorMessage, { name: "puesto" })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.cargaDetalle]
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}